<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<breadcrumbs></breadcrumbs>
<div *ngIf="widgets && widgets!.length" style="padding-left:20px; min-height:500px">
  <div *ngFor="let widget of widgets">
    <div [appLoader]="widget!.type" [props]="widget"></div>
  </div>
</div>